// M45b — InviteProvider. Owns the "is the Invite-a-friend modal open"
// state and mounts the modal once at the top of the auth tree so the
// header AppBar icon, the sidebar "Invite a friend" entry, and any
// future trigger can call `useInvite().open()` and have the same
// modal pop up. Mirrors the M32 FeedbackProvider pattern.
//
// Sits inside AuthProvider in App.tsx because the modal fetches the
// user's referral code via SECURITY DEFINER RPC — an unauthenticated
// caller would just see an error. The header icon and sidebar entry
// are also only rendered for authenticated routes (inside AppShell),
// so there's no anonymous-trigger path to worry about.
import { useCallback, useState, type ReactNode } from 'react';
import InviteFriendsModal from './InviteFriendsModal';
import { InviteContext } from './useInvite';

export function InviteProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  const openModal = useCallback(() => setOpen(true), []);
  const closeModal = useCallback(() => setOpen(false), []);

  return (
    <InviteContext.Provider value={{ open: openModal, close: closeModal }}>
      {children}
      <InviteFriendsModal open={open} onClose={closeModal} />
    </InviteContext.Provider>
  );
}
